import React from "react";
import {Icon} from "@/components/Icon.tsx";

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
}

export function ExternalLink({ href, children } : ExternalLinkProps): JSX.Element {
  return (
    <a
      href={href}
      target="_blank"
      className="underline px-1"
    >
      <Icon className="inline-block mx-0.5 mb-1" icon="mdi:external-link"></Icon>
      {children}
    </a>
  );
}